// extracted by mini-css-extract-plugin
export default {"FNodeCoverImage":"FNodeCoverImage___MrLlM"};